import type { ProjectConfig } from '@/project/types';

export default {
  // 项目模式与主题（见 src/themes）：ecom 模式，m 基础主题（主站）
  mode: 'ecom',
  theme: 'm',
  themes: ['m'],
  // 主题色
  mainColor: '#dc1e1e',
  // 导航栏配置
  globalStyle: {
    // 标题文字颜色
    navigationBarTextStyle: 'black',
    // 背景颜色
    navigationBarBackgroundColor: '#fff',
  },
  // tabBar样式配置
  tabBar: {
    color: '#999999',
    selectedColor: '#dc1e1e',
    backgroundColor: '#F8F8F8',
    // tabbar选项配置
    list: [
      {
        pagePath: 'pages/tabbar/home/home',
        text: '首页',
        iconPath: 'static/tabbar/tabBar_item0.png',
        selectedIconPath: 'static/tabbar/tabBar_item0_select.png',
      },
      {
        pagePath: 'pages/tabbar/shop/shop',
        text: '市场',
        iconPath: 'static/tabbar/tabBar_item2.png',
        selectedIconPath: 'static/tabbar/tabBar_item2_select.png',
      },
      {
        pagePath: 'pages/tabbar/notice/notice',
        text: '消息',
        iconPath: 'static/tabbar/tabBar_item3.png',
        selectedIconPath: 'static/tabbar/tabBar_item3_select.png',
      },
      {
        pagePath: 'pages/tabbar/shopCart/shopCart',
        text: '代发车',
        iconPath: 'static/tabbar/tabBar_item4.png',
        selectedIconPath: 'static/tabbar/tabBar_item4_select.png',
      },
      {
        pagePath: 'pages/tabbar/mine/mine',
        text: '我的',
        iconPath: 'static/tabbar/tabBar_item5.png',
        selectedIconPath: 'static/tabbar/tabBar_item5_select.png',
      },
    ],
  },
  // pages配置，用于vite.config.ts配置uniPages
  pages: {
  },
  // 应用升级配置（主站安卓）
  upgrade: {
    enabled: true,
    appleId: null, // iOS 暂未上架 App Store（用 mobileconfig 描述文件安装，入口在 H5 下载页）
    appStoreUrl: '',
    androidApiUrl: 'https://upnew.52dsy.com/appapi/version/latest?code=dsy-m',
    androidPackageName: 'io.dcloud.WuerSoft',
    supportMarketRedirect: true,
    // 版本管理后台应用标识（下载页拉取各端下载地址用）
    appCode: 'dsy-m',
  },
  // 百度移动统计配置
  baiduMtj: {
    mpAppKey: 'b05f2ab35a',
    appAppKey: 'c5989d83c5',
  },
  // 第三方 SDK Key 配置（生成 manifest 的 sdkConfigs，不同项目可配不同 Key；置空字符串 = 不打入对应 SDK）
  sdk: {
    // 微信开放平台（分享 + 支付）
    weixin: { appid: 'wx5b22d63885a295a1', universalLinks: '' },
    // QQ 互联（分享）
    qq: { appid: '101919039', universalLinks: '' },
    // 高德：已移除 Key（不再打入高德定位/地图原生 SDK；地图页走 web-view + URI Scheme，不依赖原生 Key）
    amap: { name: '', appkey_ios: '', appkey_android: '' },
  },
  // 资源准备配置（供 scripts/prepare-project.ts 读取）
  assets: {
    // tabbar 图标集：对应 app-assets/{tabbarIconSet}/tabbar/ 目录
    tabbarIconSet: 'm',
    // App 图标复制配置
    appIcon: {
      enabled: true,
      source: 'app-assets/m/icons',
    },
  },
} satisfies ProjectConfig;
